<template>
    <form class="form-horizontal bundle">
        <div class="alert alert-warning" role="alert" v-if="showWarningMessage">
            Invoice total cannot be negative
        </div>

        <div class="d-flex justify-content-between align-items-start pl-1">
            <b-form-checkbox
                v-model="selectAllBln"
                :disabled="!_.some(elements)"
                class="align-items-start"
                style="margin-left: -4px; margin-bottom: -1px;"
                plain
                @change="select"
                label-style
                ><b style="padding-top: 2px;"
                    >Select / Unselect All</b
                ></b-form-checkbox
            >
            <!-- Apply Item Rule Checkbox -->
            <apply-item-rule-checkbox
                v-model="applyItemRule"
                wrapper-class="pb-1"
                label-class="font-weight-bold"
                @change="evaluateItemRules"
            />
        </div>
        <hr class="mb-0" />
        <item-rows
            v-for="element in elements"
            :key="element.id"
            :element="element"
            :is-estimate="isEstimate"
            :app-data="appData"
            :apply-item-rule="applyItemRule"
        />
        <div v-if="!_.some(elements)" class="pt-3">
            <em>No item available in this template</em>
        </div>
        <hr v-if="!_.some(elements)" class="mb-0" />
    </form>
</template>
<style lang="scss">
.bundle {
    .custom-control-label {
        font-weight: normal !important;
    }

    i.famfamfam-silk {
        margin-right: 0 !important;
    }
    .form-check-inline .form-check-input {
        margin-top: 0.25rem !important;
    }
    #unit1,
    #unit2 {
        font-size: 93%;
    }
}
</style>
<script>
import { map, cloneDeep, forEach, filter, uniqBy } from "lodash";
import ItemService from "@/services/items";
import ItemRows from "./item";
import ITEMTYPES from "@/constants/item-types";
import EXTENSIONS from "@/constants/extensions";
import itemRules from "@/mixins/item-rules";
import ApplyItemRuleCheckbox from "@/components/commons/apply-item-rule-checkbox.vue";

export default {
    components: {
        ItemRows,
        ApplyItemRuleCheckbox
    },
    mixins: [itemRules],
    props: ["data", "isEstimate", "appData", "totalInvoice"],
    data() {
        return {
            elements: [],
            loaded: false,
            selectAllBln: true,
            module: "",
            showWarningMessage: false,
            applyItemRule: true
        };
    },
    watch: {
        elements: {
            handler(value) {
                let selectedElements = [];
                let totalPrice = 0;
                this.elements.forEach(element => {
                    if (element.selected) {
                        selectedElements.push(element);

                        totalPrice +=
                            Number(element.unit_price) * element.quantity +
                            Number(element.fee_price);
                    }
                });

                if (this.totalInvoice) {
                    // calculate total invoice if added
                    // show warning if negative total invoice
                    let leftAmount =
                        this.roundOff(this.totalInvoice) +
                        this.roundOff(totalPrice);
                    this.showWarningMessage = leftAmount < 0;
                    this.$emit("prevent-save", this.showWarningMessage);
                }

                this.data.selectedElements = selectedElements;
                if (this.data.selectedElements.length > 0) {
                    this.selectAllBln = true;
                } else {
                    this.selectAllBln = false;
                }
            },
            deep: true
        }
    },
    created() {
        this.$root.$on("bv::dropdown::shown", function (params) {});
    },
    mounted() {
        if (this.data.bundle_id && this.data.bundle_id.length > 0) {
            this.getCiBundle();
        }

        this.$root.$on("select_bundle", bln => {
            for (let element of this.elements) {
                element.selected =
                    element.disabled || element.disabledByRule ? false : bln;
            }
        });
    },
    methods: {
        roundOff(number) {
            return Math.round(Number(number) * 100) / 100;
        },
        select() {
            this.selectAllBln = !this.selectAllBln;
            this.$root.$emit("select_bundle", this.selectAllBln);
        },
        getCiBundle() {
            let self = this;
            this.$emit("loading");
            self.module = this.data.module !== "" ? this.data.module : "";

            var bundleIds = "";

            // check if bundle id is array or not
            // if array, its multiple bundles
            // if not array, its single bundle
            if (Array.isArray(self.data.bundle_id)) {
                forEach(self.data.bundle_id, function (value, key) {
                    bundleIds += "id[]=" + value.id + "&";
                });
            } else {
                bundleIds += "id[]=" + self.data.bundle_id + "&";
            }

            this.$http
                .get(
                    process.env.APPS +
                        "ajax/bundle/find_items?" +
                        bundleIds +
                        "module=" +
                        self.module
                )
                .then(async function (response) {
                    if (response.data.length > 0) {
                        self.elements = map(response.data, element => ({
                            ...element,
                            disabled:
                                (element.item_type ==
                                    ITEMTYPES.TYPES.TYPE_LAB ||
                                    element.item_type ==
                                        ITEMTYPES.TYPES.TYPE_RADIOLOGY) &&
                                self.appData.isDefaultProvider,
                            disabledByRule: false,
                            selected: !(
                                (element.item_type ==
                                    ITEMTYPES.TYPES.TYPE_LAB ||
                                    element.item_type ==
                                        ITEMTYPES.TYPES.TYPE_RADIOLOGY) &&
                                self.appData.isDefaultProvider
                            ),
                            max_quantity: element.max_quantity,
                            send_to_lab_value: element.send_to_lab,
                            code: ""
                        }));

                        const isAntechV6 = self._isExtensionEnabled(
                            EXTENSIONS.CODE.CODE_ANTECH
                        );

                        // if Antech V6 is enabled, get item details,
                        // then append code value into elements
                        // remove duplicate item if any
                        if (isAntechV6) {
                            let antechV6Items = self.elements.filter(
                                e => e.source == "ANTECH"
                            );

                            let antechItems = await self.getAntechItemsDetails(
                                antechV6Items
                            );

                            self.elements.forEach(element => {
                                const matchedItem = antechItems.find(
                                    item => item.id === element.id
                                );

                                if (matchedItem) {
                                    element.code = matchedItem.code;
                                }
                            });

                            // remove duplicate for source==ANTECH items from different bundles
                            self.elements = uniqBy(self.elements, item =>
                                item.source === "ANTECH" ? item.item_id : item
                            );
                        }

                        self.elements = uniqBy(self.elements, "id");
                        await self.evaluateItemRules(); // item rule validation
                        self.data.selectedElements = cloneDeep(
                            filter(self.elements, element => element.selected)
                        );
                        self.data.elements = cloneDeep(self.elements);
                        self.loaded = true;
                    } else {
                        self.loaded = false;
                    }
                })
                .finally(() => this.$emit("loaded", this.loaded));
        },
        async getAntechItemsDetails(items) {
            const requests = items.map(item =>
                ItemService.getItemDetails(item.item_id).then(response => {
                    item.code = response?.masterItem?.code;
                })
            );

            await Promise.all(requests);
            return items;
        },
        async evaluateItemRules() {
            // appData.patient is from add bundle in invoice, patient, soap, estimate, boarding
            // appData.params.patient is from start treatment
            const patient =
                this.appData?.patient || this.appData?.params?.patient;

            if (!patient || !Array.isArray(this.elements)) {
                return;
            }
            await this.checkRuleItemsBundle(
                patient,
                this.elements,
                this.applyItemRule
            );
        }
    }
};
</script>
